module.exports = __webpack_public_path__ + "img/workContents02-01_play.9de6784d.gif";